export default "__VITE_ASSET__DVj3plDr__"